import { Component } from '@angular/core';

@Component({
    selector: 'language-string',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class LanguageStringComponent {}
